import { render } from "./XmlHeadDataView.vue?vue&type=template&id=e2afdd72&scoped=true&ts=true"
import script from "./XmlHeadDataView.vue?vue&type=script&lang=ts"
export * from "./XmlHeadDataView.vue?vue&type=script&lang=ts"

import "./XmlHeadDataView.vue?vue&type=style&index=0&id=e2afdd72&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2afdd72"]])

export default __exports__